export var VolumePriceAnalysisEventSensitivity;
(function (VolumePriceAnalysisEventSensitivity) {
    VolumePriceAnalysisEventSensitivity["conservative"] = "conservative";
    VolumePriceAnalysisEventSensitivity["standard"] = "standard";
    VolumePriceAnalysisEventSensitivity["aggressive"] = "aggressive";
})(VolumePriceAnalysisEventSensitivity || (VolumePriceAnalysisEventSensitivity = {}));
export var VolumePriceDirectionalBias;
(function (VolumePriceDirectionalBias) {
    VolumePriceDirectionalBias["bullish"] = "bullish";
    VolumePriceDirectionalBias["bearish"] = "bearish";
    VolumePriceDirectionalBias["neutral"] = "neutral";
})(VolumePriceDirectionalBias || (VolumePriceDirectionalBias = {}));
export var VolumePriceCampaignPhase;
(function (VolumePriceCampaignPhase) {
    VolumePriceCampaignPhase["neutral"] = "neutral";
    VolumePriceCampaignPhase["accumulation"] = "accumulation";
    VolumePriceCampaignPhase["markup"] = "markup";
    VolumePriceCampaignPhase["distribution"] = "distribution";
    VolumePriceCampaignPhase["markdown"] = "markdown";
    VolumePriceCampaignPhase["congestion"] = "congestion";
})(VolumePriceCampaignPhase || (VolumePriceCampaignPhase = {}));
export var VolumePriceVolumeState;
(function (VolumePriceVolumeState) {
    VolumePriceVolumeState["unsupported"] = "unsupported";
    VolumePriceVolumeState["low"] = "low";
    VolumePriceVolumeState["normal"] = "normal";
    VolumePriceVolumeState["high"] = "high";
    VolumePriceVolumeState["climactic"] = "climactic";
})(VolumePriceVolumeState || (VolumePriceVolumeState = {}));
export var VolumePriceSpreadState;
(function (VolumePriceSpreadState) {
    VolumePriceSpreadState["narrow"] = "narrow";
    VolumePriceSpreadState["normal"] = "normal";
    VolumePriceSpreadState["wide"] = "wide";
})(VolumePriceSpreadState || (VolumePriceSpreadState = {}));
export var VolumePriceEffortResultState;
(function (VolumePriceEffortResultState) {
    VolumePriceEffortResultState["unsupported"] = "unsupported";
    VolumePriceEffortResultState["balanced"] = "balanced";
    VolumePriceEffortResultState["bullishEfficient"] = "bullishEfficient";
    VolumePriceEffortResultState["bearishEfficient"] = "bearishEfficient";
    VolumePriceEffortResultState["bullishAbsorption"] = "bullishAbsorption";
    VolumePriceEffortResultState["bearishAbsorption"] = "bearishAbsorption";
    VolumePriceEffortResultState["compression"] = "compression";
})(VolumePriceEffortResultState || (VolumePriceEffortResultState = {}));
export var VolumePriceAnalysisEventType;
(function (VolumePriceAnalysisEventType) {
    VolumePriceAnalysisEventType["climacticTop"] = "climacticTop";
    VolumePriceAnalysisEventType["climacticBottom"] = "climacticBottom";
    VolumePriceAnalysisEventType["stoppingVolumeTop"] = "stoppingVolumeTop";
    VolumePriceAnalysisEventType["stoppingVolumeBottom"] = "stoppingVolumeBottom";
    VolumePriceAnalysisEventType["noDemand"] = "noDemand";
    VolumePriceAnalysisEventType["noSupply"] = "noSupply";
    VolumePriceAnalysisEventType["supplyTest"] = "supplyTest";
    VolumePriceAnalysisEventType["demandTest"] = "demandTest";
    VolumePriceAnalysisEventType["upthrust"] = "upthrust";
    VolumePriceAnalysisEventType["shakeout"] = "shakeout";
    VolumePriceAnalysisEventType["confirmationOfStrength"] = "confirmationOfStrength";
    VolumePriceAnalysisEventType["confirmationOfWeakness"] = "confirmationOfWeakness";
    VolumePriceAnalysisEventType["breakoutConfirmed"] = "breakoutConfirmed";
    VolumePriceAnalysisEventType["breakoutRejected"] = "breakoutRejected";
})(VolumePriceAnalysisEventType || (VolumePriceAnalysisEventType = {}));
//# sourceMappingURL=VolumePriceAnalysisTypes.js.map